module.exports = __webpack_public_path__ + "static/media/435_DiningRoom.cc870da6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/435_DiningRoom.jpg
// module id = 105
// module chunks = 0